export const messages = {
  HOME: { TITLE: 'home', ROUTE: '/home' },
  ABOUT: { TITLE: 'About the app', ROUTE: '/about' },
  DEFINE_BOX: { TITLE: 'Morphological box', ROUTE: '/define' },
  SETTINGS: { TITLE: 'Settings', ROUTE: '/settings' },
  CREATE_SCENARIO: { TITLE: 'Create scenario', ROUTE: '/create' },
  SHOW_SCENARIO: { TITLE: 'Show scenarios', ROUTE: '/show' },
  DECISION_SUPPORT: { TITLE: 'Decision support', ROUTE: '/decide' },
  DOWNLOAD: {
    COLLECTION: 'Save collection',
    MODEL: 'Save box file',
  },
  DOWNLOAD_FILENAME_TITLE: 'Save box file',
  DOWNLOAD_FILENAME_LABEL: 'File name',
  UPLOAD: {
    COLLECTION: 'Load collection',
    MODEL: 'Load box file',
  },
  OPEN_MENU: 'Open menu',
  UPLOAD_FILE: 'Load box or collection',
  IMPORT_READ_ERROR: 'Could not read the selected file.',
  COLLECTION_LOAD_FAILED: 'Could not load the collection. Check your connection and reload the page.',
  STARTER_KIT_LOAD_FAILED: 'Could not load the starter kit. Check your connection and try again.',
  IMPORT_COLLECTION_TITLE: 'Replace collection?',
  IMPORT_COLLECTION_MSG:
    'This file contains a collection. Loading it replaces your current collection, including unsaved changes. Continue?',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  AND: 'and',
  YES: 'Yes',
  NO: 'No',
  OK: 'Ok',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  NEW_BOX: 'New morphological box',
  CATEGORIES: 'Categories',
  DIMENSION: 'Key driver',
  DIMENSION_SELECTED: 'Selected drivers',
  DIMENSIONS: 'Drivers',
  KEY_VALUE: 'Key value',
  OPTION_USAGE_LEGEND: 'Option usage in included scenarios',
  OPTION_USAGE_RANGE: 'Used {range} times in included scenarios',
  OPTION_USAGE_COUNT: '{count}x used',
  CONTEXT: 'Context',
  NONE: 'None',
  LOCATION: 'Location',
  LOCATION_TYPE: 'Location type',
  COORDINATES: 'Coordinates',
  LOCATION_NAME: 'Location name',
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude',
  MANUAL: 'Manual mode',
  Type: 'Type',
  PICK_FROM_LIST: 'Pick from list',
  ENTER_KEY_VALUE: 'Enter key value',
  EDIT_COMPONENT: 'Edit component',
  ADD_COMPONENT: 'Add component',
  GENERATE_NARRATIVE: 'Generate',
  CLEAR_NARRATIVE: 'Clear',
  NAME_NARRATIVE: 'Title of current scenario',
  SAVE_NARRATIVE: 'Save',
  SAVED_NARRATIVES: 'Saved scenarios',
  HOME_WORK_TITLE: "Choose a scenario type",
  HOME_WORK_HINT: "Start with a ready-made scenario type from the starter kit, then use it to create and compare scenarios.",
  HOME_OPTIONS_TITLE: "Adapt or create your own",
  HOME_EDIT_CARD_TITLE: "Adapt a scenario type",
  HOME_EDIT_CARD_DESC: "Add, change or remove factors and options so the selected type fits your situation.",
  HOME_AI_CARD_TITLE: "Create a new scenario type",
  HOME_AI_CARD_DESC: "Let AI propose a morphological box for your topic, or start from an empty box yourself.",
  HOME_MAP_CARD_TITLE: "Scenarios on a map",
  HOME_MAP_CARD_DESC: "Does your scenario play out at recognisable locations, such as a nuclear power plant or a monument? Turn on the map, then open Edit box and use the pencil of an option to add coordinates or a location type. These locations then appear on the map of your scenarios.",
  HOME_MAP_CARD_ENABLE: "Turn on map",
  HOME_MAP_CARD_ENABLED: "Map turned on. Add locations to options via Edit box.",
  TUTORIAL_CARD_TITLE: "Tutorial",
  TUTORIAL_CARD_DESC: "Watch how to generate a complete scenario with an AI assistant: narrative, course-of-action reflections and persona feedback in one go.",
  TUTORIAL_WATCH: "Watch tutorial",
  TUTORIAL_TITLE: "Tutorial: a complete scenario with AI",
  TUTORIAL_DESC: "From a starter kit to a decision: generate a scenario, let an AI assistant write the narrative, reflections and persona feedback as JSON, paste it in, and analyse the results.",
  TUTORIAL_NARRATION: "Narration",
  HOME_MAP_CARD_ACTIVE: "The map is on for this scenario type.",
  HOME_MAP_CARD_LOCATIONS: "Add locations",
  DECISION_BANNER_MSG: "This scenario type contains measures for decision support. Turn it on to choose measures, compare courses of action and record decisions.",
  DECISION_HELP_TITLE: "How does decision support work?",
  DECISION_HELP_STEP1: "On Create scenario, describe the situation: choose the factors of the incident and save the scenario.",
  DECISION_HELP_STEP2: "Under Decisions, choose the measures that fit the situation. Each set of measures is a course of action; create several to compare alternatives.",
  DECISION_HELP_STEP3: "Estimate the remaining probability and impact for each course of action.",
  DECISION_HELP_STEP4: "Compare the courses of action here in the overview, the comparison, the robustness view and the risk matrix.",
  DECISION_HELP_STEP5: "Record the decision and its rationale in the decision log, and export everything to Word.",
  PERSONA_CLIPBOARD_HINT: "No language model is connected, so the button copies a prompt: paste it into the chat of your AI assistant and paste the answer into the persona's feedback field. Connect a language model in Settings → LLM to generate feedback directly.",
  SETUP_LLM: "Set up language model",
  NARRATIVE_PROMPT_COPIED: "Story prompt copied. Paste it into the chat of your AI assistant and paste the answer into the story field.",
  EDIT_BOX: 'Edit box',
  NO_SAVED_NARRATIVES: 'No saved scenarios in this box yet. Create one to get started.',
  NO_MATCHING_NARRATIVES: 'No scenarios match this search.',
  OPEN_SCENARIO: 'Open scenario',
  COMPARE_SCENARIOS: 'Compare scenarios',
  HIDE_COMPARISON: 'Hide comparison',
  BOX_ACTIONS: 'More actions',
  PERMALINK: 'Copy permalink',
  PERMALINK_COPIED: 'Permalink copied to the clipboard. Paste it in an email to share this box.',
  PERMALINK_COPIED_LONG: 'Permalink copied, but it is very long: some email clients may break it. Consider sending the downloaded file instead.',
  PERMALINK_INVALID: 'The shared link is invalid or incomplete.',
  COLLECTION_ACTIONS: 'Collection tools',
  LANGUAGE_NAMES: {
    nl: 'Nederlands', en: 'English', fr: 'Français',
    de: 'Deutsch', es: 'Español', pl: 'Polski',
  },
  FILTER_NARRATIVES: 'Filter scenarios',
  FILTER_NARRATIVES_PLACEHOLDER: 'Type to filter by name...',
  NARRATIVE: 'scenario',
  INCLUDE_NARRATIVE: "Select for analysis",
  NARRATIVE_INCLUDED: "Selected for analysis",
  SELECT_NARRATIVE: 'Select scenario',
  SELECT_SCENARIO: "Scenario type",
  SELECT_GROUP_OWN: "My scenario types",
  SELECT_GROUP_STARTER: "Starter kit",
  KEY: 'Key',
  VALUE: 'Value',
  MODEL: 'Model',
  SELECTION: 'Selected value',
  EDITOR_PLACEHOLDER: 'Edit scenario',
  THRESHOLDS: 'Thresholds colors reflecting component options',
  THRESHOLD: 'Threshold value',
  COLOR: 'Color',
  ORDER: 'Order',
  COMBINATIONS: {
    POSSIBLE: 'Combinations are possible',
    IMPOSSIBLE: 'Combinations are impossible',
    IMPROBABLE: 'Combinations are improbable',
  },
  DELETE_ITEM: {
    title: 'Delete {item}',
    description:
      'Are you certain you want to delete this {item}. There is no turning back?',
  },
  NEW_SCENARIO: 'New box',
  ADD_STARTER_KIT: 'Add or update starter kit',
  ADD_STARTER_KIT_HINT: 'Adds missing starter boxes and personas and updates unedited ones. Edited items are only replaced after you confirm.',
  STARTER_KIT_ADDED: 'Starter kit: {added} added, {updated} updated.',
  STARTER_KIT_CONFLICT_TITLE: 'Overwrite edited starter items?',
  STARTER_KIT_CONFLICT_MSG: 'You changed these starter items. Select the ones to replace with the current starter-kit version. Your changes to them, including narratives and decisions, will be lost. Unselected items stay as they are.',
  STARTER_KIT_SELECT_ALL: 'Select all',
  STARTER_KIT_UPDATE: 'Update',
  STARTER_KIT_KIND_BOX: 'box',
  STARTER_KIT_KIND_PERSONA: 'persona',
  STARTER_KIT_ALREADY_PRESENT: 'The starter kit is already up to date.',
  NEW_MODEL: {
    btn: 'New collection',
    title: 'Choose a new collection',
    description:
      'Your current collection will be replaced. Download it first if you want to keep it.',
    choose: 'Choose your new collection',
  },
  DELETE_MODEL: {
    btn: 'Delete box',
    title: 'Delete the selected box',
    description:
      'Delete this box and its saved scenarios? This cannot be undone.',
  },
  INCONSISTENCIES: {
    title: 'Inconsistencies',
    SELECT_ROW_CATEGORY: 'Select row category',
    SELECT_COLUMN_CATEGORY: 'Select column category',
    SELECT_CATEGORIES_TO_START: 'Select categories to start',
    NO_DRIVERS:
      'No key drivers with values are available for this category combination',
    NAV_TITLE: 'Keyboard navigation',
    NAV_ARROWS:
      'Arrow keys: move through cells, with Shift through key drivers',
    NAV_TOGGLE: 'Space or Enter: cycle combination state',
    NAV_SHIFT_VERTICAL: 'Shift + Up/Down: change active row key driver',
    NAV_SHIFT_HORIZONTAL: 'Shift + Left/Right: change active column key driver',
  },
  saveButton: {
    label: 'Save',
    tooltip: 'Save unsaved changes',
  },
  i18n: {
    /** Label for the edit button of the RepeatList */
    editRepeat: 'Edit',
    /** Label for the create button of the RepeatList */
    createRepeat: 'Add',
    /** Label for the delete button of the RepeatList */
    deleteItem: 'Delete',
    /** Label for the agree button of the RepeatList */
    agree: 'Yes',
    /** Label for the disagree button of the RepeatList */
    disagree: 'No',
    /** Pick */
    pick: 'Pick',
    /** Pick one */
    pickOne: 'Pick one',
    /** Pick one or more */
    pickOneOrMore: 'Pick one or more',
    /** Cancel button text */
    cancel: 'Cancel',
    /** Save button text */
    save: 'Save',
  },
  COMP: {
    AVAILABLEBUDGET: 'Budget',
    BEHAVIOURDURINGPREPARATION: 'Behaviour during preparation',
    CAPABILITIES: 'Capability',
    COMPARTMENTSPRESENT: 'Compartments present',
    CRIMINALPHASE: 'Criminal phase',
    DURATION: 'Duration',
    EQUIPMENT: 'Equipment',
    EXISTINGINFRA: 'Existing infra',
    IMPACT: 'Impact',
    INTENT: 'Bystander intent',
    LOCATION: 'Location',
    LOCATION2: 'Location',
    MODUSOPERANDIDURINGEXECUTION: 'Mode of operation',
    MOTIVATION: 'Motivation',
    NARRATIVE: 'Narrative',
    NARRATIVE_PLACEHOLDER:
      'Describe the context in which the incident took place, such as a description of the (geographic) location, the person or building that must be protected, the way an actor obtains information, at what time did the action take place, under what weather circumstances, how many persons were involved in the action, from which organisation, how did they obtain access, or which means/weapons were employed.',
    OBJECT: 'Object',
    OPENCOMPARTMENTS: 'Open compartment',
    PEOPLEDENSITY: 'Person density',
    PERSONS: 'Person',
    PHYSICALANGLEOFATTACKDURINGEXECUTION: 'Physical angle of attack',
    PHYSICAL_ANGLE: 'Physical angle',
    PRIVACYAWARENESS: 'Privacy awareness',
    RELATIONOWNEROBJECTANDOWNERSECURITYSYSTEM:
      'Relation owner object and owner security system',
    RESPONSIBILITY: 'Responsibility',
    SCENARIOS: 'Scenario',
    SECURITYAWARENESS: 'Security awareness',
    TARGETTYPE: 'Target type',
    THREATDIRECTION: 'Threat direction',
    ACTOR: 'Actor',
    ACTION: 'Action',
    ACCESS: 'Access',
    MEANS: 'Means',
    TYPEOFENVIRONMENT: 'Environment type',
    TYPEOFOBJECT: 'Type of object',
    WEAPON: 'Weapon',
    WEATHERBEHAVIOUR: 'Weather behaviour',
    WEATHERTYPE: 'Weather condition',
    PI: 'Protected interest (target)',
    MEANSWEAPON: 'Means/weapon',
    MISSIONCONTEXT: 'Mission context',
    ADVERSARY: 'Adversary',
    C2HEADQUARTERS: 'C2-HQ location',
    TARGET: 'Target',
    DELIBERATEACTION: 'Deliberate action',
    MEANS2: 'Means of attack',
    MEANS3: 'Means for action',
    MEANS4: 'Means for access',
    ACCESS2: 'Means of access',
    MEANS2ACCESS: 'Means to access',
  },
  MODEL_NAMES: {
    0: 'Empty model',
    1: 'Starter kit',
  },
  MODEL_DESC: {
    0: 'Start with an empty morphological box.',
    1: 'Ten exercise boxes in your language with examples, constraints, prose templates and LLM prompts.',
  },
  JSON_NOT_VALID: 'JSON model file not valid! Aborting.',
  NO_NARRATIVE: 'No scenario generated in 100 tries!',
  ALL_LOCKED_WARNING:
    'All components are locked — no new scenario can be generated. Clear the current scenario first.',
  SPEC_CATS:
    'First specify some categories, where each category contains some key drivers.',
  TRANSPOSE_BOX: {
    COLUMNS: 'Show key drivers as columns',
    ROWS: 'Show key drivers as rows',
  },
  EXPORT2WORD: {
    TITLE: 'Export to Word',
    DESC: 'Which scenario do you want to export?',
    CURRENT: 'Current',
    SELECTED: 'Selected',
    ALL: 'All',
    INCLUDE_BOX: 'Include the morphological box (one table per category, selected values highlighted)',
    INCLUDE_DECISIONS: 'Include the decision analysis (overview, comparison of courses of action, risk matrix and decision log)',
  },
  HIDE_INCONSISTENT: 'Hide inconsistent combinations',
  GOAL: {
    TITLE: 'Goal',
    DESC: 'ScenarioSpark is a web application that can be used to systematically create and manage a set of scenarios for risk management activities.',
  },
  USAGE: {
    TITLE: 'Usage',
    DESC: 'ScenarioSpark supports the user in creating and compiling a representative set of scenarios that can be used in the various steps of the risk management process.',
  },
  SECURITY: {
    TITLE: 'Security',
    DESC: 'All information used and entered is processed and stored exclusively locally.',
  },
  SUMMARY:
    'A free tool to support you in creating new scenarios using a morphological box. First, you define the aspects that are of interest in your domain. Next, you specify variations for each aspect. And finally, you either manually create new scenarios, or become inspired by generating possible scenarios automatically.',
  SET_LANGUAGE: 'Set language',
  SCENARIO_LOADED_MSG: 'Box loaded',
  COLLECTION_LOADED_MSG: 'The box collection is loaded',
  SCENARIO_NOT_LOADED_MSG:
    'The box was not loaded; it may already be in the collection.',
  IMPORT_CONFLICT_TITLE: 'Box already exists',
  IMPORT_CONFLICT_MSG:
    'A box named "{name}" is already in your collection. What would you like to do?',
  IMPORT_OVERWRITE: 'Overwrite',
  IMPORT_AS_COPY: 'Add as copy',
  SCENARIO_CREATED_MSG: 'Box created',
  COPY_TO_CLIPBOARD: 'Copy table to clipboard',
  GROUP: { SELECTED: 'Selected scenarios', UNSELECTED: 'Unselected scenarios' },
  MORE_ACTIONS: 'More actions',
  CLONE_NARRATIVE: 'Clone',
  INCLUDE_DECISION_SUPPORT: 'Activate decision support',
  INCLUDE_MAP_SUPPORT: 'Activate map support',
  SETTINGS_GENERAL: "General",
  SETTINGS_OPTIONS: "Options",
  SETTINGS_NARRATIVE: "Narrative",
  SETTINGS_MAP: "Map",
  SETTINGS_STRUCTURE: "Structure of the box",
  HIDE_INCONSISTENT_HINT: "When creating a scenario, hide options that are impossible given your selection, instead of only marking them.",
  INCLUDE_MAP_SUPPORT_HINT: "Show a map when defining the box and when creating and viewing scenarios, to place factors at a location.",
  INCLUDE_DECISION_SUPPORT_HINT: "Show measure categories, courses of action and the decision page.",
  MAP_CONFIG: 'Map configuration',
  MAP_UNITS: 'Map units',
  METRIC: 'Metric',
  IMPERIAL: 'Imperial',
  OSM_AMENITIES: 'OSM Amenities',
  TOGGLE_MAP: 'Show/Hide map',
  ZOOM_LEVEL: 'Zoom level',
  CIRCLE: 'Circle',
  ELLIPSE: 'Ellipse',
  OSM_QUERY: 'OSM Query',
  RADIUS: 'Radius (m)',
  RADII: 'Radii (comma separated, in meters)',
  MAJOR_AXIS: 'Major axis (m)',
  MINOR_AXIS: 'Minor axis (m)',
  ORIENTATION: 'Orientation',
  ORIENTATION_DESC: 'Angle in degrees (0 = North) or reference ID',
  IS_DECISION_CATEGORY: 'For decision support',
  DECISION_CATEGORY_HINT: "Factors in a decision category are manual: they are not generated, you choose them after describing the situation. Decision categories are only shown when decision support is activated.",
  DECISION_CATEGORIES_HIDDEN: "Decision categories ({count}) are hidden.",
  DECISION_CATEGORIES_OPEN_SETTINGS: "Open Settings",
  DECISIONS: "Decisions",
  DECISIONS_HINT: "Choose the measures that fit the situation above. Options that conflict with the situation are greyed out.",
  EXCLUDED_BY: "excluded by {situation}",
  COURSES_OF_ACTION: "Courses of action",
  COURSE_OF_ACTION: "Course of action",
  COA_ACTIVE: "active",
  ADD_COA: "Add",
  DUPLICATE_COA: "Duplicate",
  RENAME_COA: "Rename course of action",
  DELETE_COA: "Delete course of action",
  COA_NAME: "Name of the course of action",
  COA_NOTES: "Notes on this course of action",
  COA_HAS_CONFLICTS: "Contains measures that conflict with the situation",
  COA_CONFLICT: "{value} conflicts with the situation ({situation})",
  REFLECT_ON_DECISIONS: "Ask LLM: reflect on decisions",
  COA_REFLECTION: "Reflection on this course of action",
  DECISION_PROMPT_COPIED: "Decision prompt copied. Paste it into the chat of your AI assistant and paste the answer into the reflection field.",
  DECISION_REFLECTION_ERROR: "Could not generate or copy the reflection. Try again.",
  DECISION_REFLECTION_DISCARDED: "The reflection was not saved: the scenario or course of action changed while it was generated.",
  NO_DECISION_CATEGORIES: "This box has no decision categories. Mark a category as \"For decision support\" in Settings to compare measures here.",
  DECISION_VIEW_OVERVIEW: "Overview",
  DECISION_VIEW_COA: "Compare courses of action",
  DECISION_VIEW_ROBUSTNESS: "Robustness",
  COMPARE_SCENARIO: "Scenario to compare",
  SHOW_DIFFERENCES_ONLY: "Show differences only",
  NO_INCLUDED_NARRATIVES: "No scenarios are selected for analysis yet. Select scenarios on the Create scenario page to compare them here.",
  NO_CURRENT_NARRATIVE: "No scenario is open. Open or save a scenario on the Create scenario page first.",
  NO_COAS: "This scenario has no courses of action yet. Add them on the Create scenario page.",
  NO_COA_DIFFERENCES: "All courses of action choose the same measures.",
  NO_DECISION_SELECTED: "none",
  ROBUSTNESS_HINT: "Which measures hold up across the current scenario and those selected for analysis? Each column is a scenario with its active course of action; a measure chosen in all scenarios is a safe first step, one chosen in a single scenario depends on how the situation develops.",
  ROBUSTNESS_ONE_SCENARIO: "Robustness compares two or more scenarios. Save another scenario on the {page} page and select it for analysis to see which measures hold up in all of them.",
  SCENARIO_CURRENT: "current",
  ROBUSTNESS_MEASURE: "Measure",
  ROBUSTNESS_CHOSEN: "Chosen",
  ROBUSTNESS_EXCLUDED: "Excluded by the situation",
  ROBUSTNESS_UNUSED: "Not used",
  ROBUSTNESS_CHOSEN_IN: "Chosen in",
  ROBUSTNESS_COUNT: "{count} of {total}",
  ROBUSTNESS_ROBUST: "Robust: chosen in every scenario",
  ROBUSTNESS_SPECIFIC: "Scenario-specific: chosen in one scenario only",
  SUGGESTED_WHY: "Why this suggestion",
  SUGGESTED_HINT: "Per factor, the measures with the highest risk-weighted count over the active courses of action. Measures that are impossible in every compared situation, or together with a stronger pick, are skipped; unlikely combinations are allowed, so check them yourself.",
  SUGGESTED_PICK: "chosen in {count} of {total} scenarios, weight {weight}",
  SUGGESTED_SKIPPED_EXCLUDED: "{value} skipped: impossible in every compared situation ({causes})",
  SUGGESTED_SKIPPED_CONFLICT: "{value} skipped: impossible together with {causes}",
  SUGGESTED_NONE: "No suggestion: no scenario chose a measure",
  SUGGESTED_NONE_EXCLUDED: "No suggestion: every chosen measure is impossible in all compared situations",
  SUGGESTED_NONE_CONFLICT: "No suggestion: every chosen measure is impossible together with a stronger pick",
  RESIDUAL_PROBABILITY: "Probability after this course of action",
  RESIDUAL_IMPACT: "Impact after this course of action",
  RESIDUAL_RISK: "Residual risk",
  COA_RISK_HINT: "Optional: estimate the risk that remains when this course of action is carried out. It is compared with the risk of the situation.",
  SITUATION_RISK_HINT: "Risk of the situation if no action is taken: the probability that it escalates or causes (further) harm, and the impact if it does.",
  RISK_DOWN_FROM: "Down from {before}",
  RISK_UP_FROM: "Up from {before}",
  RISK_SAME_AS: "Same as the situation ({before})",
  COA_RISK_SUMMARY: "Residual risk: {after} (situation: {before})",
  COA_RISK_SUMMARY_SHORT: "Residual risk: {after}",
  RISK_BEFORE_AFTER: "Risk: situation → after the course of action",
  RISK_TRANSITION: "{before} → {after}",
  RISK_CHANGE: { lower: "Lower risk", same: "Same risk", higher: "Higher risk" },
  RISK_NOT_SET: "not set",
  DECISION_VIEW_RISK: "Risk matrix",
  RISK_MATRIX_CAPTION: "Risk matrix: probability (rows) × impact (columns)",
  RISK_MATRIX_HINT: "Numbers are the current scenario (1) and those selected for analysis (situation risk); letters are the courses of action of the selected scenario (residual risk).",
  RISK_MATRIX_MARKER: "Marker",
  RISK_MATRIX_ITEM: "Scenario or course of action",
  RISK_MATRIX_CELL: "Probability {probability}, impact {impact}: risk {risk}",
  RISK_MATRIX_LEGEND: "Risk level",
  RISK_LEVEL_HINT: { 0: 'Acceptable; no extra measures needed.', 1: 'Acceptable; monitor the situation.', 2: 'Reduce the risk where reasonably possible.', 3: 'Not acceptable; measures needed with priority.', 4: 'Not acceptable; act immediately.' },
  RISK_MATRIX_UNPLACED: "Not plotted (probability or impact not set): {items}",
  RISK_MATRIX_EMPTY: "Set the probability and impact of the included scenarios to plot them.",
  CRITERIA_SCORING: "Criteria scoring (optional)",
  CRITERIA_HINT: "Score each course of action per criterion from 1 (poor) to 5 (good) and set how much each criterion counts (0 = ignore). The weighted score is the sum of weight × score.",
  CRITERIA: { effect: "Effect", speed: "Speed", capacity: "Capacity", safety: "Responder safety", legality: "Legality", acceptance: "Public acceptance" },
  CRITERIA_CRITERION: "Criterion",
  CRITERIA_WEIGHT: "Weight",
  CRITERIA_WEIGHT_FOR: "Weight of {criterion}",
  CRITERIA_SCORE_FOR: "Score of course of action {coa} for {criterion}",
  CRITERIA_TOTAL: "Weighted score",
  CRITERIA_RANK: "Rank",
  CRITERIA_TOTAL_OF: "{total} of {max}",
  CRITERIA_MISSING: "{count} not scored",
  DECISION_EXPORT: "Export to Word",
  DECISION_EXPORT_TITLE: "Decision support",
  DECISION_EXPORT_DATE: "Exported on {date}",
  DECISION_LOG: "Decision log",
  DECISION_LOG_HINT: "Record the decisions you take, with their rationale. Entries are kept when a scenario or course of action is deleted.",
  DECISION_LOG_EMPTY: "No decisions recorded yet.",
  RECORD_DECISION: "Record decision",
  EDIT_DECISION: "Edit decision",
  DELETE_DECISION: "Delete decision",
  DECISION_LOG_DATE: "Date and time",
  DECISION_LOG_SCENARIO: "Scenario",
  DECISION_LOG_DECISION: "Decision",
  DECISION_LOG_RATIONALE: "Rationale",
  DECISION_LOG_AUTHOR: "Decided by",
  DECISION_LOG_REMOVED: "removed",
  DECISION_LOG_NO_SCENARIO: "No specific scenario",
  DECISION_LOG_NO_COA: "No specific course of action",
  DECISION_LOG_EDITED: "edited {date}",
  CRITERIA_NOT_SCORED: "not scored",
  DECISION_PROMPT_TITLE: "Turn on decision support?",
  DECISION_PROMPT_MSG: "This box contains decision categories, such as measures you choose after describing the situation. Turn on decision support to choose and compare them.",
  DECISION_PROMPT_LATER_NOTE: "You can change this later in Settings.",
  DECISION_PROMPT_ENABLE: "Turn on",
  DECISION_PROMPT_NOT_NOW: "Not now",
  PROBABILITY: 'Probability of occurence',
  IMPACT: 'Impact',
  RISK: 'Risk',
  RISK_PLACEHOLDER: 'Probability x Impact',
  PROB5: { 0: 'Very low', 1: 'Low', 2: 'Medium', 3: 'High', 4: 'Very high' },
  IMP5: { 0: 'Very low', 1: 'Low', 2: 'Medium', 3: 'High', 4: 'Very high' },
  RISK5: { 0: 'Very low', 1: 'Low', 2: 'Medium', 3: 'High', 4: 'Very high' },
  SUGGESTED_APPROACH: {
    TITLE: 'Suggested approach',
    DESC: 'The suggested approach is a (risk-)weighted combination of the selected counter-measures.',
  },
  TEMPLATE: {
    TITLE: 'Template string for fluid text',
    DESC: 'Write a paragraph where XXX is replaced by the value for key factor 1, etc. Empty lines are converted to paragraphs.',
  },
  SELECT_PERSONA: 'Select relevant persona for scenario',
  SELECT_PERSONA_HELP: 'Capture how each selected persona perceives a saved scenario, responds to measures, and needs to be informed or involved.',
  PERSONA_IMPRESSION: 'Persona feedback',
  COPY_PERSONA_PROMPT: 'Copy feedback prompt',
  COPY_PERSONA_PROMPT_SHORT: 'Copy',
  COPY_PERSONA_PROMPT_FOR: 'Copy feedback prompt for {persona}',
  GENERATE_PERSONA_FEEDBACK: 'Generate feedback',
  GENERATE_PERSONA_FEEDBACK_SHORT: 'Generate',
  GENERATE_PERSONA_FEEDBACK_FOR: 'Generate feedback for {persona}',
  PERSONA_PROMPT_COPIED: "Feedback prompt copied. Paste it into the chat of your AI assistant and paste the answer into this field.",
  PERSONA_PASTE_HINT: 'Paste the LLM response directly into the field above; it saves automatically.',
  PERSONA_FEEDBACK_ERROR: 'Could not generate or copy feedback. Try again.',
  PERSONA: {
    1: 'Persona',
    n: 'Personas',
  },
  IMAGE: 'Image',
  SAVE: 'Save',
  EDIT: 'Edit',
  MARKDOWN_FIELD_EMPTY: "Click to add text",
  LLM: 'LLM',
  SERVICE: 'Service',
  PROVIDER: 'Provider',
  SYSTEM_PROMPT: 'System prompt',
  USER_PROMPT: 'Narrative prompt',
  EFFECT_PROMPT: 'Effect prompt',
  PERSONA_PROMPT: 'Persona prompt',
  COMMUNICATIONS_PROMPT: 'Communications prompt',
  TEMPERATURE: {
    BTN: 'Temperature',
    DESC: 'How creative should the LLM be (max = 1)?',
  },
  API_KEY: 'API key',
  URL: 'URL',
  ASK_LLM: 'Ask LLM',
  INCLUDE_LLM: 'Include in LLM',
  OLLAMA_URL:
    'Hostname (and port, optionally via a [proxy](https://github.com/erikvullings/proxy))',
  ADV_EDIT: 'Code editor',
  TOGGLE: { SHOW: 'Show map', HIDE: 'Hide map' },
  AUTO_CREATE: {
    BTN: 'Auto create',
    COUNT: 'LLM auto create count',
    COUNT_DESC: 'How many scenarios do you want to generate at once?',
  },
  AUTO_CREATE_MSG: {
    1: `Auto create 1 scenario`,
    n: 'Auto create {n} scenarios',
  },
  COPY_BOX: {
    LABEL: 'Copy box',
    TITLE: 'Copy table to clipboard',
    TOAST: 'Morphological box copied to clipboard.',
  },
  PROMPT_TYPE: {
    PROMPTS: 'Prompts',
    LABEL: 'Prompt type',
    NARRATIVE: 'Narrative prompt',
    EFFECT: 'Effect prompt',
    PERSONA: 'Persona prompt',
    COM: 'Communications prompt',
    DECISION: "Decision-reflection prompt",
  },
  LLM_DEFAULT_NARRATIVE_PROMPT:
    'Use the following elements to define a realistic scenario.',
  LLM_INCLUDED_CATEGORIES: 'Included categories',
  LLM_PROMPT_TEXT: 'Prompt',
  LLM_CATEGORY_REQUIRED: 'Select at least one category for this prompt.',
  LLM_DEFAULT_PERSONA_PROMPT:
    'Describe how the target persona perceives this situation, including any proposed measures and how they should be informed or involved when relevant. Ground the feedback in the scenario and persona descriptions; do not invent details. Return only the feedback for the target persona, ready to paste into their feedback field. Do not add a heading, persona name, or code fences.',
  LLM_PERSONA_CONTEXT: 'Selected personas and descriptions:\n{personas}',
  LLM_PERSONA_TARGET: 'Write feedback only for: {persona}',
  LLM_SCENARIO_TEXT: 'Scenario narrative:\n{narrative}',
  LLM_SITUATION: "Situation (use these elements to describe the incident):",
  LLM_SUGGESTED_ACTIONS: "Suggested actions (measures to describe and assess):",
  LLM_NO_MEASURES_SELECTED: "No measures were selected: describe only the incident and do not invent measures or a solution.",
  LLM_DEFAULT_DECISION_PROMPT: "You are an experienced crisis-management advisor. Assess the course of action below for the given situation. Stay grounded in the given situation and scenario narrative; do not invent facts. Be concise: at most 250 words, in Markdown, with exactly these parts: **Verdict** (2–3 sentences on suitability, timing and sequence), **Strengths** (2 bullets), **Risks and gaps** (2–3 bullets, including what is missing) and **Improvement** (1 concrete recommendation). Do not add a title or code fences.",
  LLM_DECISION_SITUATION: "Situation (the incident the decisions respond to):",
  LLM_COA_DECISIONS: "Course of action {coa}: decisions to assess:",
  LLM_COA_NO_DECISIONS: "Course of action {coa} has no decisions selected yet: point out which decisions are needed.",
  LLM_OTHER_COAS: "Other courses of action considered (for contrast only; do not assess them):",
  LLM_COMBINED_INTRO: "Complete all tasks below for one scenario. Answer with a single JSON object in a ```json code block and nothing else.",
  LLM_COMBINED_TASK_NARRATIVE: "Task: write the scenario narrative",
  LLM_COMBINED_CURRENT_NARRATIVE: "Current narrative (improve it and keep what still fits):\n{narrative}",
  LLM_COMBINED_TASK_DECISIONS: "Task: assess each course of action",
  LLM_COMBINED_TASK_PERSONAS: "Task: write feedback for each persona, based on your narrative",
  LLM_COMBINED_OUTPUT: "Output format (these rules override earlier formatting instructions): fill in the JSON template below. Keep every id unchanged, put a short descriptive title in \"title\", write the text values in Markdown, use \\n for line breaks inside strings, and add no other fields or text outside the code block.",
  COMBINED_PROMPT: "All-in-one prompt",
  COMBINED_PROMPT_TITLE: "One prompt for the narrative, course-of-action assessments and persona feedback; paste back the JSON answer",
  COMBINED_TITLE: "All-in-one AI prompt",
  COMBINED_HINT: "The prompt is on your clipboard. Paste it into your AI assistant (for example Copilot) and paste its JSON answer below. This window stays open meanwhile.",
  COMBINED_COPY: "Copy prompt",
  COMBINED_COPIED: "Prompt copied. Paste the JSON answer below.",
  COMBINED_PASTE: "AI answer (JSON)",
  COMBINED_PARSE_ERROR: "No valid JSON found in this answer. Ask the AI to return only the JSON code block.",
  COMBINED_APPLY: "Apply",
  COMBINED_APPLIED: "Scenario updated from the AI answer.",
  COMBINED_UNMATCHED: "Not recognised, skipped: {names}",
  COMBINED_REPLACES: "replaces existing text",
  COMBINED_FIELD_TITLE: "Title",
  COMBINED_FIELD_NARRATIVE: "Narrative",
  COMBINED_HINT_API: "Generate the answer with the configured AI service, or copy the prompt and paste the JSON answer below. Check the result before applying it.",
  COMBINED_GENERATE: "Generate",
  COMBINED_GENERATE_ERROR: "The AI service did not return an answer. Check the LLM settings or copy the prompt instead.",
  LLM_FIELD_PROMPTS: "Prompt per field",
  LLM_FIELD_PROMPTS_DESC: "The all-in-one prompt stays available. Also show a prompt button next to the narrative, each assessment and each persona, to (re)generate only that part.",
  AI_NARRATIVE: "Ask LLM: write narrative",
  COPY_NARRATIVE_PROMPT: "Copy narrative prompt",
  NARRATIVE_PASTE_HINT: "Copy the prompt, ask your AI assistant and paste its answer into the narrative field.",
  NARRATIVE_GENERATE_ERROR: "Could not generate the narrative. Check the LLM settings.",
  RESPONSE_INSTRUCTIONS:
    'Start your response with a short, descriptive title on its own line, then a blank line, then the main content.',
  WIZARD_STEP1_TITLE: 'Box details',
  WIZARD_STEP1_SUBTITLE: 'Name and describe your box',
  WIZARD_STEP2_TITLE: 'Key Drivers',
  WIZARD_STEP2_SUBTITLE: 'Define the morphological category and key drivers',
  WIZARD_STEP3_TITLE: 'Driver Options',
  WIZARD_STEP3_SUBTITLE: 'Optionally add options for each driver',
  WIZARD_CATEGORY_INFO: 'Category details',
  WIZARD_COMPONENTS_INFO: 'Key drivers (dimensions)',
  WIZARD_VALUES_INFO: 'Select a driver to add options:',
  WIZARD_NO_COMPONENTS: 'No drivers defined yet. Go back to step 2.',
  WIZARD_VALUES_FOR_COMPONENT: 'Options for {component}',
  WIZARD_DEFAULT_CATEGORY_NAME: 'Initial Morphological Box',
  WIZARD_NEXT: 'Next',
  WIZARD_PREVIOUS: 'Back',
  WIZARD_COMPLETE: 'Create box',
  WIZARD_SKIP: 'Skip',
  LLM_WIZARD_TITLE: 'Create box with AI',
  LLM_WIZARD_STEP1_TITLE: 'Define Requirements',
  LLM_WIZARD_STEP1_SUBTITLE: 'Specify what you want to generate',
  LLM_WIZARD_STEP1_DESC:
    'Fill in the details below to customize your morphological box generation:',
  LLM_WIZARD_STEP2_TITLE: 'Review Prompt',
  LLM_WIZARD_STEP2_SUBTITLE: 'Review and edit the complete prompt',
  LLM_WIZARD_STEP2_DESC:
    'Review the combined prompt below. You can edit it if needed:',
  LLM_WIZARD_STEP3_TITLE: 'Configure LLM',
  LLM_WIZARD_STEP3_SUBTITLE: 'Choose LLM service and settings',
  LLM_WIZARD_STEP3_DESC:
    'Configure how you want to generate the morphological box:',
  LLM_WIZARD_STEP4_TITLE: 'Generate box',
  LLM_WIZARD_STEP4_SUBTITLE: 'Generate or paste the result',
  LLM_WIZARD_STEP4_CLIPBOARD_DESC:
    'The prompt is ready. Copy it and use an external LLM to generate the morphological box:',
  LLM_PURPOSE: 'Purpose',
  LLM_PURPOSE_HELP:
    'What do you want to explore or design? E.g., "crisis management scenarios for national emergency planning"',
  LLM_DOMAIN: 'Domain',
  LLM_DOMAIN_HELP:
    'Specify the field or context, e.g., "disaster response", "cybersecurity", "military operations"',
  LLM_OUTPUT_TYPE: 'Output Type',
  LLM_OUTPUT_TYPE_HELP:
    'One morphological box, multiple boxes, scenario-focused, measure-focused, or both?',
  LLM_CONSTRAINTS: 'Constraints or Focus Areas',
  LLM_CONSTRAINTS_HELP:
    'E.g., "Include socio-political, environmental, and technological factors"',
  LLM_DETAIL_DEPTH: 'Detail Depth',
  LLM_DETAIL_DEPTH_HELP:
    'E.g., "Include 6-7 detailed options per factor, each with a one-sentence definition"',
  LLM_LANGUAGE: 'Output Language',
  LLM_LANGUAGE_HELP:
    'The language for the generated content, e.g., "English", "Dutch"',
  LLM_FULL_PROMPT: 'Complete Prompt',
  LLM_ENDPOINT: 'Generation Method',
  LLM_CLIPBOARD: 'Copy to Clipboard (use external LLM)',
  LLM_OLLAMA: 'Generate with Ollama',
  LLM_OPENAI: 'Generate with OpenAI',
  LLM_OLLAMA_URL_HELP: 'Ollama API URL, e.g., http://localhost:11434/api/chat',
  LLM_OPENAI_URL_HELP: 'OpenAI API URL (leave empty for default)',
  LLM_OLLAMA_MODEL_HELP: 'Model name, e.g., gemma2, llama3, qwen2.5',
  LLM_OPENAI_MODEL_HELP: 'Model name, e.g., gpt-4o-mini, gpt-4o',
  LLM_COPY_PROMPT: 'Copy Prompt to Clipboard',
  TEMPLATE_PROMPT_COPIED: 'Template prompt copied to clipboard',
  TEMPLATE_PROMPT_COPY: 'Copy LLM prompt to clipboard',
  LLM_PROMPT_COPIED: 'Prompt copied to clipboard!',
  LLM_PASTE_OUTPUT: 'Paste the LLM output below:',
  LLM_GENERATE: 'Generate with LLM',
  LLM_GENERATING: 'Generating with LLM...',
  LLM_ERROR: 'Error generating',
  LLM_GENERATED_MARKDOWN: 'Generated Markdown',

  IMPORT_FROM_SPREADSHEET: 'Paste from Spreadsheet',
  IMPORT_PASTE_DATA: 'Paste Spreadsheet Data',
  IMPORT_PLACEHOLDER:
    'Paste tab-separated data from Excel/Google Sheets here...\n\nFirst row = key driver names, each column = options for that driver.',
  IMPORT_PARSE: 'Parse & Import',
  IMPORT_NO_DRIVERS: 'No key drivers detected. Check your paste.',
  IMPORT_NO_DATA: 'No spreadsheet data detected. Paste a table and try again.',
  IMPORT_NEEDS_TWO_COLUMNS:
    'Import requires at least 2 columns (driver names and options).',
  CLOSE_MESSAGE: 'Close message',
  SEARCH_SCENARIO_TYPE: 'Search scenario types…',
  NO_SCENARIO_TYPE_FOUND: 'No scenario types found',
  COVERAGE_MENU: "Generate covering set…",
  COVERAGE_TITLE: "Generate scenarios that cover the box",
  COVERAGE_DESC: "Creates distinct scenarios in which every option is used about equally often, instead of picking them at random. Locked options are kept, impossible combinations are never used and unlikely ones are avoided. Included scenarios that already exist count towards the balance.",
  COVERAGE_COUNT: "Number of scenarios",
  COVERAGE_BATCH_NAME: "Batch name (used as a prefix for the scenario names)",
  COVERAGE_BATCH_DEFAULT: "Batch",
  COVERAGE_PAIRS: "Also spread combinations of options (pairwise)",
  COVERAGE_START: "Generate",
  COVERAGE_STOP: "Stop",
  COVERAGE_PROGRESS: "{done} of {total} scenarios",
  COVERAGE_DONE: "{count} scenarios added to \"{batch}\"",
  COVERAGE_EXHAUSTED: "Only {count} new distinct, consistent scenarios could be created.",
  DELETE_BATCH_MENU: "Delete generated batch…",
  DELETE_BATCH_TITLE: "Delete a batch of generated scenarios",
  DELETE_BATCH_SELECT: "Batch",
  DELETE_BATCH_KEEP_TEXT: "Keep scenarios that already have a narrative",
  DELETE_BATCH_DONE: "{count} scenarios deleted",
  SHOW_GENERATED: "Show {count} generated scenarios without a narrative",
};
